// extracted by mini-css-extract-plugin
module.exports = {"block":"DepartmentBlock_block__2J_Uy","departmentName":"DepartmentBlock_departmentName__34Vdl","department":"DepartmentBlock_department__j7kTZ"};